import { fetchBlogs } from "../../services/fetchBlogs";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Curve from "../../curve";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const { data } = await fetchBlogs();
        //   console.log(data?.publication?.posts?.edges);
        setBlogs(data?.publication?.posts?.edges);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Curve>
      <header className="hero">
        <h1 className="hero-heading">
          read my <span className="primary-color">blogs</span>
        </h1>
      </header>
      {loading ? (
        <p className="section">loading blogs...</p>
      ) : (
        blogs.map(({ node: { id, title, brief, url, publishedAt } }, index) => (
          <section
            className={`section ${index % 2 === 0 ? "section-ow" : ""}`}
            key={id}
          >
            <div className="container container-center">
              <h1>{title}</h1>
              <small>{new Date(publishedAt).toDateString()}</small>
              <p>{brief}</p>
            </div>
            <Link to={url} className="link link-primary" target="_blank">
              Read More
            </Link>
          </section>
        ))
      )}
    </Curve>
  );
};

export default Blog;
